import { Component, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { AppBuilderService } from 'app/forms/services/app-builder/app-builder.service';

@Component({
  selector: 'tog-aws-settings-form',
  templateUrl: './aws-settings-form.component.html',
  styleUrls: ['./aws-settings-form.component.scss']
})
export class AwsSettingsFormComponent implements OnDestroy {
  awsSettingsForm: FormGroup;
  formChangeSubscription: Subscription;
  shouldReset: Subscription;

  @Input() allowOneForm: boolean = false;

  constructor(private _fb: FormBuilder,
              private _ab: AppBuilderService) {
    this.awsSettingsForm = _fb.group({
      access_key_id: ['', Validators.required],
      secret_access_key: ['', Validators.required],
      bucket: ['', Validators.required],
      region: ['', Validators.required]
    });
    this.formChangeSubscription = this.awsSettingsForm.valueChanges.subscribe((formValue) => {
      this._ab.updateForm(this.awsSettingsForm, 'aws', this.allowOneForm);
    });
    this.shouldReset = this._ab.getReset('aws').subscribe(() => {
      let allowanceStatus = this.allowOneForm;
      this.allowOneForm = false;
      this.awsSettingsForm.reset();
      this.allowOneForm = allowanceStatus;
    });
  }

  ngOnDestroy() {
    if (this.formChangeSubscription) this.formChangeSubscription.unsubscribe();
    if (this.shouldReset) this.shouldReset.unsubscribe();
  }

}



// WEBPACK FOOTER //
// /app/src/app/forms/components/aws-settings-form/aws-settings-form.component.ts